import Banner from 'gatsby-theme-husky/src/common/Banner/Banner';

import './BannerOverride.scss';

export default Banner;
